import { SessionStorageService } from './WebStorageService';
import { DelayedActionsService } from 'services/storage/DelayedActionsService';

export default {
  session: new SessionStorageService({}),
  delayedActions: new DelayedActionsService(),
};
